function footHeight() {
  const $foot = document.querySelector('.foot')

  const resize = _.debounce(function() {
    if ($foot) {
      const height = $foot.offsetHeight
      document.documentElement.style.setProperty('--footHeight', `${height}px`)
    }
  }, 50)

  bus.on('resize', resize)
  bus.on('resizeContainer', resize)
  resize()
}

export default footHeight
